import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

/** Emitted when user chooses an action from the offline map context menu (e.g. Add note). */
export interface AddFromMapNotePayload {
  type: string;
  note: {
    address?: string;
    address_jp?: string;
    /** JSON string `{ lat, lng }` for map pin / timeline location */
    geolocation?: string;
  };
}

/** Point + optional resolved address from map context menu. */
export interface MapContextMenuPoint {
  lat: number;
  lng: number;
  address?: string;
}

export type MapContextMenuCommand =
  | { command: 'areaOfInterest'; point: MapContextMenuPoint }
  | { command: 'addPatrolCamera'; point: MapContextMenuPoint }
  | { command: 'goToLocation'; point: MapContextMenuPoint }
  | { command: 'mapAnnotation'; point: MapContextMenuPoint }
  | { command: 'dispatch'; point: MapContextMenuPoint; buildingId?: string; snapshotDataUrl?: string }
  | { command: 'floorPlansViewer'; buildingId: string }
  | { command: 'locateRoom'; buildingId: string };

@Injectable({ providedIn: 'root' })
export class MapService {

  public addFromMap = new Subject<AddFromMapNotePayload>();
  public openCameras = new Subject<any>();

  /** Area of interest, go to location popup, or annotate — from offline map right-click menu. */
  public mapContextMenuCommand = new Subject<MapContextMenuCommand>();

  constructor() {
  }
}
